import React, { useContext } from 'react'
import { Flex, Box } from 'pcln-design-system'
import HotelsTonight from '../HotelsTonight/HotelsTonight'
import PromoFeatureBox from '../PromoFeatureBox'
import Form from '../Hotels/SearchForm/Form'
import BootstrapDataContext from '../../context/BootstrapDataContext'
import { handleSubmitForHotels } from '../Hotels/SearchForm/utils'
import StyledHeading from '../StyledHeading'
import MobileHeaderWrapper from '../MobileHeaderWrapper/MobileHeaderWrapper'
import useMostRecentBooking from '../CustomHooks/useMostRecentBooking'
import CrossSell from '../CrossSell'
import ACE_KEYS from '../../constants/aceKeys'
import useFirstNameInAceContentForVIP from '../CustomHooks/useFirstNameInAceContentForVIP'
import useSEMSearchHeadline from '../CustomHooks/useSEMSearchHeadline'
import MarketingTout from '../Promos/MarketingTout/MarketingTout'
import usePrePopFormHeadline from '../CustomHooks/usePrePopFormHeadline'
import FindMyTripBanner from '../Hotels/FindMyTripBanner'
import ConditionalRender from '../ConditionalRender/ConditionalRender'
import useContentfulSearchFormHeadlines from '../CustomHooks/useContentfulSearchFormHeadlines'

const PRIMARY_HEADING_FALLBACK = 'Find your next hotel deal'
const SECONDARY_HEADING_FALLBACK = 'Use code FREEDOM20 to save on Express Deals'

export default function HomeMobile() {
  const mostRecentBooking = useMostRecentBooking()
  const {
    signInStatus: { signedIn, passiveSignIn },
    customer: { firstName }
  } = useContext(BootstrapDataContext)
  const isSignedIn = signedIn || passiveSignIn
  const prePopHeadline = usePrePopFormHeadline()
  const SEMHeadline = useSEMSearchHeadline()
  const form = useContentfulSearchFormHeadlines('searchFormHotels')

  useFirstNameInAceContentForVIP(
    firstName,
    ACE_KEYS.homepage.vip.withNameHeadingKey
  )
  const headingVIPKey = firstName
    ? ACE_KEYS.homepage.vip.withNameHeadingKey
    : ACE_KEYS.homepage.vip.defaultHeadingKey
  const subheadlingValues = {
    aceContent: isSignedIn
      ? [ACE_KEYS.homepage.hotel.signedInSubHeadingKey]
      : undefined,
    text: form?.mobileSubheadline || SECONDARY_HEADING_FALLBACK
  }
  const headingValues = {
    aceContent: isSignedIn ? [headingVIPKey] : undefined,
    text: isSignedIn
      ? PRIMARY_HEADING_FALLBACK
      : prePopHeadline ||
        SEMHeadline ||
        form?.mobileHeadline ||
        PRIMARY_HEADING_FALLBACK
  }

  return (
    <>
      <MobileHeaderWrapper selectedProductName="Hotels" />
      <Box m={3}>
        <Flex flexDirection="column" mb={3}>
          <StyledHeading {...headingValues} fontSize={3} tag="h1" />
          <StyledHeading
            color="text.light"
            mt={1}
            fontSize={1}
            {...subheadlingValues}
            tag="h2"
          />
        </Flex>
        <Form onSubmit={handleSubmitForHotels} />
      </Box>
      <ConditionalRender
        experimentCode="HP_FMT"
        variantValue="VARIANT"
        experiment={<FindMyTripBanner isMobile />}
      />
      <Box m={3}>
        {mostRecentBooking ? (
          <CrossSell booking={mostRecentBooking} />
        ) : (
          <PromoFeatureBox />
        )}
      </Box>
      <MarketingTout />
      <Box m={3}>
        <HotelsTonight />
        <Box textAlign="center" mt={4} width={1}>
          <div id="div-gpt-ad-1544641976893-0" />
        </Box>
      </Box>
    </>
  )
}
